// トップのメッセージ節の出現演出: <section data-mp-message class="… is-pending">
//   [data-mp-message-photo]   … PC 用の写真（飾り 2 枚と主写真）
//   [data-mp-message-title]   … 見出し
//   [data-mp-message-body]    … 本文（子要素を 1 つずつ順に出す）
//   [data-mp-message-collage] … SP 用のコラージュ（中の img）
// 初期化前は CSS（.is-pending）が要素を隠し、4 秒で必ず表示する保険が入っている。
// JS が動いたら .is-pending を外し、画面に入ったタイミングで順に .is-loaded を付ける。

import { canAnimate, revealElement, revealSequence, observeReveal } from './reveal.js';

export function setupMessage() {
  const section = document.querySelector('[data-mp-message]');
  if (!section) return;

  const photos = [...section.querySelectorAll('[data-mp-message-photo]')];
  const title = section.querySelector('[data-mp-message-title]');
  const body = section.querySelector('[data-mp-message-body]');
  const copy = [title, ...(body ? [...body.children] : [])].filter(Boolean);
  const collage = [...section.querySelectorAll('[data-mp-message-collage] img')];

  const desktopTargets = [...photos, ...copy]; // PC ではこの順で少しずつずらして出す
  const all = [...new Set([...desktopTargets, ...collage])];
  all.forEach((element) => element.classList.add('is-reveal-item'));
  [...photos, ...collage].forEach((element) => element.classList.add('is-reveal-photo'));

  section.classList.remove('is-pending');

  if (!canAnimate) {
    all.forEach((element) => revealElement(element));
    return;
  }

  const desktop = window.matchMedia('(min-width: 960px)').matches;
  if (desktop) {
    collage.forEach((element) => revealElement(element)); // 非表示だが状態だけ揃える
    const trigger = section.querySelector('[data-mp-message-trigger]') || section;
    observeReveal([trigger], () => revealSequence(desktopTargets), { threshold: 0, rootMargin: '0px 0px -28% 0px' });
  } else {
    photos.forEach((element) => revealElement(element));
    observeReveal([title || section], () => revealSequence(copy, 70), { threshold: 0, rootMargin: '0px 0px -16% 0px' });
    observeReveal(collage, (element) => revealElement(element), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
  }
}
